/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useRef, useState } from "react";
import "./style.less";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import logo from "@/assets/w-Logo.png";
import useWindowScrollHeight from "@/hooks/useWindowScrollHeight";


const NavBar = (props) => {
  const getScrollHeight = useWindowScrollHeight();
  const location = useLocation();
  const pathName = location?.pathname;

  useEffect(() => {}, []);
  const { list } = props;
  const navList = [
    { path: "/", key: "/", name: "HOME" },
    { path: "/product", key: "product", name: "PRODUCTS & SERVICES" },
    { path: "/industries", key: "industries", name: "INDUSTRY SOLUTIONS" },
    { path: "/about", key: "about", name: "ABOUT US" },
  ];

  const NavClick = (path, event) => {
    console.log(path);
    if (!path) {
      event.preventDefault();
    }
  };

  return (
    <>
      <div className={`nav_bar ${getScrollHeight > 0 ? "window_scroll" : ""}`}>
        <div className="nav_warp">
          <div className="logo">
            <Link to={"/"}>
              <img src={logo} />
            </Link>
          </div>
          <div className="nav_list">
            {navList.map((val, index) => {
              return (
                <div className="nav_item" key={index}>
                  <div className="nav_item_content">
                    {/* <Link
                      to={val.path}
                      className={
                        (pathName === val.path) ||
                        (pathName.startsWith(`/${val.key}`) && val.key !== "/")
                          ? "active"
                          : ""
                      }
                      onClick={(e) => NavClick(val.path, e)}
                    >
                      {val.name}
                    </Link> */}
                    <NavLink
                      to={val.path}
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      {val.name}
                    </NavLink>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="nav_contact">
          <NavLink
            to="/contact"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <span className="line l_top ease-out"></span>
            <div className="txt">CONTACT</div>
            <span className="line l_bottom ease-up"></span>
          </NavLink>
        </div>
        </div>
      </div>
    </>
  );
};

export default NavBar;
